import { useQuery } from "@tanstack/react-query";
import { client_v2 } from "utils/api";
import { Loader } from "components";

const getActivityStatus = ({
  gdn_pack_status,
  gdn_pack_id,
  grn_id,
  grn_status,
}) => {
  if (gdn_pack_id) {
    switch (gdn_pack_status) {
      case "completed":
        return (
          <>
            <span className="label label--success">
              <span className="text-10">Zakończony</span>
            </span>
            <span> ({gdn_pack_id})</span>
          </>
        );
      case "picked":
      case "packing":
        return (
          <>
            <span className="label label--warning">
              <span className="text-10">Pakowane</span>
            </span>
            <span> ({gdn_pack_id})</span>
          </>
        );
      case "new":
      case "picking":
        return (
          <>
            <span className="label label--purple">
              <span className="text-10">W kompletacji</span>
            </span>
            <span> ({gdn_pack_id})</span>
          </>
        );
      default:
        return "Bezczynny";
    }
  }
  if (grn_id) {
    if (["open", "active", "with_errors", "completed"].includes(grn_status)) {
      return (
        <>
          <span className="label label--purple">
            <span className="text-10">Przyjmowanie dostawy</span>
          </span>
          <span> ({grn_id})</span>
        </>
      );
    }
  }
  return "Bezczynny";
};

const Activity = () => {
  const { isLoading, isFetching, data, refetch } = useQuery(
    ["user_activity"],
    () => client_v2.get("/users/activity"),
    {
      select: (res) => res.data,
      retry: false,
    }
  );

  const is_loading = isLoading || isFetching;

  const handleClick = ({ gdn_pack_id, grn_id }) => {
    if (gdn_pack_id) {
      window.open(`/packing/gdn_pack/${gdn_pack_id}`, "_blank");
    }
    if (grn_id) {
      window.open(`/grns/${grn_id}`, "_blank");
    }
  };

  return (
    <div className="dashboard">
      <div className="history-box__header">
        <span className="title">Aktywność</span>
        {is_loading ? (
          <Loader size="20" />
        ) : (
          <button className="btn btn-default" onClick={refetch}>
            Odśwież
          </button>
        )}
      </div>
      {data?.length > 0 && (
        <ul className="history-box__body">
          {data
            .sort((a, b) => a.full_name?.localeCompare(b?.full_name))
            .map(
              ({
                full_name,
                packing_station_name,
                gdn_pack_status,
                gdn_pack_id,
                grn_id,
                grn_status,
              }) => (
                <li
                  key={full_name}
                  style={
                    !gdn_pack_id && !grn_id
                      ? {
                          pointerEvents: "none",
                        }
                      : {}
                  }
                  onClick={() => handleClick({ gdn_pack_id, grn_id })}
                >
                  <span>
                    {full_name} ({packing_station_name || "-"})
                  </span>
                  <span>
                    {getActivityStatus({
                      gdn_pack_status,
                      gdn_pack_id,
                      grn_id,
                      grn_status,
                    })}
                  </span>
                </li>
              )
            )}
        </ul>
      )}
    </div>
  );
};

export default Activity;
